import { Col, Row, Typography } from 'antd';
import { ReactComponent as ChevronRightSmallIcon } from 'assets/icons/chevron-right-small.svg';
import { SimHistoryInfo } from 'domain/entities/SimulateEntity';
import React from 'react';
import { DATE_FORMAT } from 'utilities/constants/DATE';
import { commonHelpers } from 'utilities/helpers';
import { SCREEN_NAME } from '../../../../../infrastructure/config/CONSTANTS';

interface SimHistoryCardInfo {
    index?: number;
    simulationTitle?: string;
    screenName: string;
    dispayDate: string;
}

export const SimHistoryCard = ({
    index,
    data,
    hasBorder = true,
    detailClick,
    type = 'history',
}: {
    index?: number;
    data?: SimHistoryInfo;
    hasBorder?: boolean;
    detailClick?: (data?: SimHistoryInfo) => void;
    type: 'history' | 'beforeSim' | 'confirmSim';
}) => {
    const [cardInfo, setCardInfo] = React.useState<SimHistoryCardInfo>();

    React.useEffect(() => {
        if (type == 'history') {
            setCardInfo({
                simulationTitle: data?.simulationTitle || '',
                screenName: SCREEN_NAME[data?.screen as keyof typeof SCREEN_NAME] || '',
                dispayDate:
                    commonHelpers.formatDate(
                        data?.simulationTiming,
                        DATE_FORMAT.FORMAT_DATE_WITH_DAY,
                    ) || '',
            });
        } else if (type === 'beforeSim') {
            setCardInfo({
                screenName: data?.name || '',
                dispayDate:
                    commonHelpers.formatDate(
                        data?.simulationTiming,
                        DATE_FORMAT.FORMAT_DATE_WITH_DAY,
                    ) || '',
            });
        } else if (type === 'confirmSim') {
            setCardInfo({
                screenName: data?.name || '',
                dispayDate:
                    commonHelpers.formatDate(
                        data?.simulationTiming,
                        DATE_FORMAT.FORMAT_DATE_WITH_DAY,
                    ) || '',
            });
        }
    }, [data]);

    return (
        <>
            <Row
                className={`flex flex-nowrap justify-between items-center gap-0.5 py-3 px-0 w-full ${hasBorder ? 'card-border-b' : ''}`}
            >
                <Col span={2}>
                    <div className="text-center text-sm font-bold leading-[200%]">
                        {index ? index + 1 : 1}
                    </div>
                </Col>
                <Col span={20}>
                    {cardInfo?.simulationTitle && (
                        <Row className="flex-nowrap w-full">
                            <Typography.Text
                                ellipsis={{
                                    tooltip: cardInfo?.simulationTitle,
                                }}
                                className="self-stretch text-sm font-bold leading-[200%] w-full"
                            >
                                {cardInfo?.simulationTitle}
                            </Typography.Text>
                        </Row>
                    )}
                    <Row className="w-full flex-nowrap justify-between">
                        <Typography.Text
                            ellipsis={{
                                tooltip: cardInfo?.screenName,
                            }}
                            style={type == 'history' ? { fontSize: 10 } : { fontSize: 14 }}
                            className="font-bold leading-[200%] w-full"
                        >
                            {cardInfo?.screenName}
                        </Typography.Text>
                        <Col className="w-fit">
                            <Typography.Text
                                style={{ fontSize: 10 }}
                                ellipsis={{
                                    tooltip: cardInfo?.dispayDate,
                                }}
                                className="font-bold leading-[200%]"
                            >
                                {cardInfo?.dispayDate}
                            </Typography.Text>
                        </Col>
                    </Row>
                </Col>
                <Col
                    span={1}
                    className="w-fit min-w-[18px] cursor-pointer"
                    onClick={() => {
                        detailClick && detailClick(data);
                    }}
                >
                    <ChevronRightSmallIcon width={16} height={16} />
                </Col>
            </Row>
        </>
    );
};
